var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBBCMC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-out-icon",
    transform: "translate(-1804.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1805.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2609807,15.0810811 C13.2609807,16.6931555 11.9416155,18 10.3140961,18 L2.94688459,18 C1.31936517,18 0,16.6931555 0,15.0810811 L0,2.91891892 C0,1.30684451 1.31936517,0 2.94688459,0 L10.3140961,0 C11.9416155,0 13.2609807,1.30684451 13.2609807,2.91891892",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.64842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.721947,4.1931006 C15.8627449,4.1931006 15.9981706,4.24714931 16.1002779,4.34409332 L20.8275318,8.8323028 C21.0476067,9.04124917 21.0566282,9.38903967 20.8476819,9.60911464 C20.8401879,9.61700778 20.832461,9.62467651 20.8245115,9.63211069 L16.0972576,14.0529164 C15.8756109,14.2601947 15.5278984,14.2485468 15.3206201,14.0269001 C15.2254294,13.9251108 15.1724734,13.7909535 15.1724734,13.6515895 L15.1715239,11.6448948 L9.64399758,11.6450235 C9.34053164,11.6450235 9.09452389,11.3990158 9.09452389,11.0955498 L9.09452389,7.28540628 C9.09452389,6.98194034 9.34053164,6.73593259 9.64399758,6.73593259 L15.1715239,6.73589482 L15.1724734,4.74257429 C15.1724734,4.43910835 15.4184811,4.1931006 15.721947,4.1931006 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.555831c65d3e6a2d97388c1132e0c39c.svg";
export { ForwardRef as ReactComponent };